import { emergencyOrderContainer } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getEmergencyOrderContainerList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(emergencyOrderContainer.emergencyOrderContainerBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getEmergencyOrderContainerObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrderContainer.emergencyOrderContainerBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getCodecoInboundLogs(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(emergencyOrderContainer.codecoInboundLogBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportCodecoInboundLogs(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrderContainer.codecoInboundLogBase}export/`, { params, responseType: "blob" })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportEmergencyOrderContainers(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrderContainer.emergencyOrderContainerBase}export/`, { params, responseType: "blob" })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  getChartSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrderContainer.emergencyOrderContainerBase}chart_summary/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  createManualDA(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${emergencyOrderContainer.emergencyOrderContainerBase}${id}/create_da/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getDaRatePreview(id, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrderContainer.emergencyOrderContainerBase}${id}/da_rate_preview/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  simulateGateEvent(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(emergencyOrderContainer.adminMockGateEventBase, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
